import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'

const IncompatibleItemsSubcomponent = ({ closeHandler }) =>
  <ButtonWrapper>
    <Button bolder onClick={ closeHandler }>
      Cancel
    </Button>
  </ButtonWrapper>

export default IncompatibleItemsSubcomponent

IncompatibleItemsSubcomponent.propTypes = {
  closeHandler: PropTypes.func
}

const ButtonWrapper = styled.div`
  width: 100%;
  text-align: right;
  margin-top: 40px;
`
